<aside class="block-schedule">
    <rwidget-route-stops [routeId]="routeId" [directionId]="directionId"></rwidget-route-stops>
</aside>
